import React from 'react';
import { createStyles, makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles(({ palette, breakpoints }: Theme) => createStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#F6F6F6',
    height: '100%',
    flexDirection: 'column',
    [breakpoints.up('sm')]: {
      padding: '50px',
    },
  },
  body: {
    maxWidth: '620px',
    width: '100%',
    backgroundColor: palette.common.white,
    padding: '55px 1em',
  },
  container: {
    maxWidth: '410px',
    margin: 'auto',
  },
}), { name: 'PageContainer' });


const PageContainer = ({children}: React.ComponentProps<'div'>) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.body}>
        <div className={classes.container}>
          {children}
        </div>
      </div>
      <div style={{height:'100px'}} />
    </div>
  )
};

export default PageContainer;
